import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetScheduleParams } from '../../../ts/ServerApi/types/actionParams';

export class SetSubscriptionsScheduleRequest extends Request<ISetScheduleParams, IResult> {
  constructor(ids: string[], scheduleId: string) {
    super('setSubscriptionsSchedule', {
      ids: ids,
      scheduleId: scheduleId
    });
  }
}
